import { jsx as r } from "react/jsx-runtime";
const h = ({ size: o = 96, color: l = "currentColor", ...t }) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: `0 0 ${o} ${o}`,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ r(
      "path",
      {
        d: "M39.4065 37.4293C39.4065 35.3178 41.6922 33.9982 43.5208 35.0539L62.8634 46.2214C64.692 47.2771 64.692 49.9164 62.8634 50.9721L43.5208 62.1396C41.6922 63.1953 39.4065 61.8757 39.4065 59.7642L39.4065 37.4293Z",
        fill: l
      }
    )
  }
);
export {
  h as PlayBorderlessIcon
};
